// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsInitiator;
(function (HhsInitiator) {
    HhsInitiator["AssistRx"] = "ARX";
    HhsInitiator["Trialcard"] = "TC";
})(HhsInitiator || (HhsInitiator = {}));
//# sourceMappingURL=hhsInitiator.js.map